import React from 'react';
export function ToolingSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200" data-id="element-3051">
      <h2 className="text-2xl md:text-3xl font-bold text-[#1967a5] mb-6 border-b border-gray-200 pb-4" data-id="element-3052">
        Tooling for EDM
      </h2>
      <div className="grid md:grid-cols-2 gap-8 items-start" data-id="element-3053">
        <div className="space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-3054">
          <p data-id="element-3055">
            Every WEDM comes with a basic table having a left, right and back
            rail. Depending on the size of the shop, you may have just a few -
            or maybe even a few hundred - pieces of tooling holders and
            fixtures. The key to obtaining greater productivity when it comes to
            tooling is standardization and palletization. By having everyone use
            the same type of system, setup times can be significantly reduced.
            Often we think it is just easier to set up and indicate a part on
            the back rail. It will only take "just a few minutes" to set up.
            Compared to the two or three hours of cutting time, it seems a very
            short time. This could not be further from the truth. Take a closer
            look at the amount of work that could fit on a wire EDM pallet or
            holder.
          </p>

          <div data-id="element-3056">
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-3057">
              Benefits to palletizing:
            </h3>
            <ul className="list-disc list-inside space-y-2 text-base" data-id="element-3058">
              <li data-id="element-3059">
                Wire EDM is able to cut around the clock while someone presets
                parts on wire pallets.
              </li>
              <li data-id="element-3060">
                You are able to switch out parts quickly in just a few seconds.
              </li>
              <li data-id="element-3061">Table chuck repeatability within 0.000080".</li>
              <li data-id="element-3062">You are able to switch work from one machine to another.</li>
              <li data-id="element-3063">
                You can stop a part, then go to the hot job and back again.
              </li>
              <li data-id="element-3064">Standard tooling is used throughout the shop and CMM.</li>
            </ul>
          </div>

          <div data-id="element-3065">
            <h3 className="text-xl font-bold text-navy mb-3" data-id="element-3066">
              CAD/CAM Software
            </h3>
            <p data-id="element-3067">
              Just like standardizing your tooling, having only one programming
              system throughout the shop is a must in order to streamline the
              production of CNC programs. Each station should have the same
              software release level, identically configured PCs and should have
              the latest postprocessors for the specific type of wire EDM
              machines to avoid the editing of programs after post processing.
              Adopting a standard programming technique eliminates the
              programmers having to constantly interface with the EDM operators.
            </p>
            <p className="mt-4" data-id="element-3068">
              We truly live in a global economy today. There is one particular
              company that has divisions in North America, Asia and Europe.
              Through a common network system it has two or three programmers
              programming eight hours a day. A programmer often starts an urgent
              job in the afternoon and when he comes back the next morning the
              program is ready and waiting after being completed by a programmer
              3,000 miles away at another division.
            </p>
          </div>
        </div>
        <div data-id="element-3069">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/EDM%20Images/Wire%20EDM%20Tooling.jpg" alt="Wire EDM Tooling" className="block w-full h-auto rounded-lg shadow-sm border border-gray-200 sticky top-24" data-id="element-3070" />
        </div>
      </div>
    </div>;
}